import { render } from "./BlFormFieldMulticheckbox.vue?vue&type=template&id=56fce10f&scoped=true"
import script from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"

import "./BlFormFieldMulticheckbox.vue?vue&type=style&index=0&id=56fce10f&scoped=true&lang=css"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fce10f"]])

export default __exports__